/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChart from "../../atomicComponents/BarLineChart/BarLineChart";
import DashboardSection from "./DashboardSection";
import { useHistory } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { setQuarter } from "date-fns";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import { useLocation } from "react-router-dom";
import DashboardSectionDropDown from "../DashboardContainer/DashBoardSectionDropDown";
import { useSelector } from "react-redux";
import { ConsoleIcon } from "evergreen-ui";
import Marquee from "react-fast-marquee";

function JLRP2PMainComp() {
  const history = useHistory();

  const location = useLocation();

  const token = localStorage.getItem('ApiToken');

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };

  const quarterOptionss = [
    // { value: "undefined", label: "Select" },
    // { value: "0", label: "-All-" },
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const monthOptionss = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const quarterToMonths = {
    2: ["4", "5", "6"], // Apr–Jun
    3: ["7", "8", "9"], // Jul–Sep
    4: ["10", "11", "12"], // Oct–Dec
    1: ["1", "2", "3"], // Jan–Mar
  };

  // const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const { API_BASE_URL } = config;

  const { showPopup } = usePopupManager();

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);
  const [TowerOption, setTowerOption] = useState([]);

  const [RefreshedDate, setRefreshedDate] = useState([]);

  const currentDateTime = new Date;
  const yeasterdayDate = new Date(currentDateTime);
  yeasterdayDate.setDate(currentDateTime.getDate()-1);
  const stripedYesterrdayDate = yeasterdayDate.toLocaleDateString();

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);
  const [tower, setTower] = useState(TowerOption[0]);

  const [JLRUKData, setJLRUKData] = useState([]);

  const [rolesDataFetched, setRolesDataFetched] = useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-entity-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          if (roles["entity"] === "JLR") {
            setEntityOptions(response.data[0].jlr);
          } else {
            setEntityOptions(response.data[0].all);
          }
          setRolesDataFetched(true);
        });
    } catch (error) {
      console.error("Error fetching finance-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-year-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-year options:", error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-month-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchTowerOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/JLRUK-tower`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const data = response.data;
          // setTowerOptions(data);
          // setCostTowerOptions(data)
          // setMarginTowerOptions(data);
          setTowerOption(data);
        });
    } catch (error) {
      console.error("Error fetching finance-tower options:", error);
    }
  };

  const fetchRefreshedDate = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-Refreshed-Date`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setRefreshedDate(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchJLRUKData = async (towerSelected = null) => {
    // const entityval = entity?.value;
    const entityval = initialFilters.entityData?.value || entity?.value;
    // const yearval = Array.isArray(year)? year.map((item) => item?.value): [];
    const yearval = filters?.yearData?.value || year?.value;
    const monthval = month?.map((item) => item?.value);
    // const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.value;
    // const towerval = tower?.value;
    const towerval = towerSelected?.value || tower?.value;
    setIsLoading(true);
    const axios = require("axios");
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval,
      selectedTower: towerval,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/P2P-JLR_UK_drilldown`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Authorization: "Basic YWRtaW4xOjEyMw==",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        setJLRUKData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const JLRUKdatasets = [
    {
      type: "line",
      label: "Timeliness",
      data: JLRUKData.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.4,
      fill: false,
      pointRadius: 6,
    },
    {
      type: "bar",
      label: "Within SLA",
      data: JLRUKData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: JLRUKData.map((item) => item.outsideSLA),
      backgroundColor: "#FF0000",
    },
  ];

  const hasRedirected = useRef(false);

  const handleApply = (changed = {}) => {
    // const entityValue = entity?.value?.toLowerCase() || "";
    // console.log("entityvalue---------:",entityValue)
    // let routeKey = entityValue?.split(" ")[0];
    // console.log("routeKey---------:",routeKey)

    // if(entityValue !== 'all')
    // {
    //   const routeKey = Object.keys(entityRouteMap).find((key) =>
    //     entityValue.includes(key)
    //   );

    //   let targetRoute
    //   if (routeKey) {
    //     targetRoute = entityRouteMap[routeKey];
    //   }

    //   if (!hasRedirected.current) {
    //     hasRedirected.current = true;
    //     history.push(entityRouteMap, {
    //       entityData: entity,
    //       yearData: year,
    //       quarterData: quarter,
    //       monthData: month,
    //     });
    //   }
    // }
    // if(routeKey !== 'jlr')
    // {
    //   // const routeKey = Object.keys(entityRouteMap).find((key) =>
    //   //   entityValue.includes(key)
    //   // );
    //   // console.log("routeKey----------:",routeKey)

    //   let targetRoute = "/Procure-To-Pay";
    //   // if (routeKey) {
    //   //   targetRoute = entityRouteMap[routeKey];
    //   // }

    //   if (!hasRedirected.current) {
    //     hasRedirected.current = true;
    //     history.push(targetRoute, {
    //       entityData: entity,
    //       yearData: year,
    //       quarterData: quarter,
    //       monthData: month,
    //     });
    //   }
    // }

    const entityRouteMap = {
      agratas: "/Procure-To-Pay/Agratas-Main",
      jlr: "/Procure-To-Pay/JLR-Main",
    };
    
    const entityValue = entity?.value?.toLowerCase();
    let entitySlice = entityValue?.split(" ")[0] || "jlr";
    // console.log("entityvalue---------:", entitySlice);
    
    let targetRoute = "/Procure-To-Pay"
    
    if (entitySlice !== "all") {
      const routeKey = Object.keys(entityRouteMap).find((key) =>
      entitySlice.includes(key)
      );
    
      if (routeKey) {
        targetRoute = entityRouteMap[routeKey];
      }
    }
    
    if (!hasRedirected.current) {
      hasRedirected.current = true;
    
      history.push(targetRoute, {
        entityData: entity,
        yearData: year,
        quarterData: quarter,
        monthData: month,
      });
    }

    if (Array.isArray(entity) && entity.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (Array.isArray(year) && year.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    const selectedTower = changed.tower;

    if (entity?.value) {
      fetchJLRUKData(selectedTower);
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
    }
  };

  useEffect(() => {
    hasRedirected.current = false;
  }, [entity]);

  const handleEntityChange = (selected) => {
    if (selected) {
      setEntity(selected);
      setFilters((prev) => ({ ...prev, entityData: selected }));
    } else {
      setEntity([]);
    }
  };

  const handleYearChange = (selected) => {
    if (selected) {
      setYear(selected);
      setFilters((prev) => ({ ...prev, yearData: selected }));
    } else {
      setYear([]);
    }
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleMonthChange = (selected) => {
    if (selected && selected.length > 0) {
      // store array of values like [1,2,3]
      setMonth(selected);
      setFilters((prev) => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters((prev) => ({ ...prev, quarterData: selected }));
      const selectedMonths = selected.flatMap(
        (q) => quarterToMonths[q.value] || []
      );
      const filteredMonths = monthOptionss.filter((m) =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters((prev) => ({ ...prev, monthData: filteredMonths }));
    } else {
      // No quarter selected
      setQuarter([]);
      setMonth([]);
      setFilters((prev) => ({
        ...prev,
        quarterData: [],
        monthData: [],
      }));
    }
  };

  const handleTowerChange = (selected) => {
    setTower(selected);
    handleApply({ tower: selected });
  };

  const handleReset = () => {
    setShowDashboard(false);
    setEntity(null);
    setYear(null);
    setMonth(null);
    setQuarter(null);
  };

  useEffect(() => {
    if (roles && !rolesDataFetched) {
      fetchEntityOptions();
      fetchYearOptions();
      // fetchMonthOptions();
      fetchTowerOptions();
      fetchRefreshedDate();
      // fetchQuarterOptions();
    }
  }, [roles, rolesDataFetched]);

  useEffect(() => {
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData.value
        );
        if (ent) setEntity(ent);
      }

      if (filters.yearData) {
        const yr = yearOptions.find(
          (opt) => opt.value === filters.yearData.value
        );
      //   const yr = yearOptions.filter((opt) =>
      //   filters.yearData.some((m) => m.value === opt.value)
      // );
        if (yr) {
          setYear(yr);
          // shouldApply = true;
        }
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptionss.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }
      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptionss.filter((opt) =>
          filters.quarterData.some((m) => m.value === opt.value)
        );
        if (qtr.length > 0) setQuarter(qtr);
      }

      setHasApplied(true);
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year
            <span style={{ color: "red" }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti={true}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                styles={customStyles}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            ></div>
            <p
              className="mb-3"
              style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}
            >
              Loading...
            </p>
          </div>
        </div>
      )}

      {showDashboard && (
        <div>
          <div className="row">
            <div className="col-md-12">
              {/* <DomainTile title="JLR" showBackButton={true} detailState={initialFilters} mainPagePath="/Procure-To-Pay" /> */}
              <DomainTile
                title="JLR"
                showBackButton={true}
                mainPagePath="/Procure-To-Pay"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-lg-12 mb-1 h-75">
              <DashboardSectionDropDown
                // title="Billing Input Validation"
                disableDetailView={true}
                detailPath="/Procure-To-Pay"
                CostElement={tower}
                handleCostElementChange={handleTowerChange}
                CostElementOption={TowerOption}
                showDownloadView ={false}
                placeholder="Select tower"
                popupContent="Manual CSV DATA"
              >
                <BarLineChart
                  datasets={JLRUKdatasets}
                  chartData={JLRUKData}
                  height={290}
                />
              </DashboardSectionDropDown>
            </div>
          </div>
          <div className="row" style={{fontSize:"12px", color:"red"}}>
          <Marquee speed={30} gradient={false}>
          Last Refresh Date:- <b>{stripedYesterrdayDate}</b>
          </Marquee>
        </div>
        </div>
      )}
    </>
  );
}

export default JLRP2PMainComp;